export const closeButtonStyles = {
    background: 'none',
    border: 'none',
    color: '$resultsTableTextLighter',
    lineHeight: 0,
    margin: 0,
    padding: 0,
}

export const avatarNameWrapper = {
    alignItems: 'center',
    display: 'flex',
    gap: '10px',
}

export const actionsWrapper = {
    alignItems: 'center',
    display: 'flex',
    gap: '5px',
}
